module.exports = __webpack_public_path__ + "img/device_1004_1.5fb0e57e.svg";